import axios from 'axios'

export const farms = {
    state:{
        farms: [],
        homefarms: [],
        farmsOriginal: [],
        farmsbyid: {},
        investment: [],
        farmsCount: '',
        usersCount: '',
        investCount: '',
        transactions: [],
        investmentbyid: {}
    },
    mutations:{
      Login(state,token){
        state.token = token
        state.isUserLogged = true
      },
      Farms(state, data){
        state.farms = data.data
        state.farmsOriginal = data.data
      },
      HomeFarm(state, data){
        state.homefarms = data.data
      },
      FarmsById(state, data){
          state.farmsbyid = data.data
      },
      investment(state, data){
        state.investment = data.data
      },
      Transactions(state, data){
        state.transactions = data.data
      },
      FarmCount(state, data){
        state.farmsCount = data.data
      },
      UsersCount(state, data){
        state.usersCount = data.data
      },
      InvestCount(state, data){
        state.investCount = data.data
      },
      InvestmentById(state, data){
        state.investmentbyid = data.data
      },
      SetFarmFilter(state,word){
        word=word.toLowerCase()
        state.farms = state.farmsOriginal.filter(function (item) {
            return item.name.toLowerCase().includes(word.toLowerCase());
        });
      },
        
    },
    actions:{
    
      // =================Farms management =============
      GetFarms: ({commit}) => {
        return new Promise((resolve, reject)=>{
          axios.get("/farms")
          .then(({data, status})=>{
            if(status === 200){
              commit('Farms', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      HomeFarm: ({commit}) => {
        return new Promise((resolve, reject)=>{
          axios.get("/homefarm")
          .then(({data, status})=>{
            if(status === 200){
              commit('HomeFarm', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      AddFarm: ({commit},payload) =>{
        return new Promise((resolve, reject)=>{
          axios.post("/farms", payload)
          .then(({status, data})=>{
            if(status === 200){
              commit()
              resolve(data);
              
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
    },

      GetFarmsById: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.get("/farms/"+payload)
          .then(({data, status})=>{
            if(status === 200){
              commit('FarmsById', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      FarmsInvest: ({commit},payload) =>{
          return new Promise((resolve, reject)=>{
            axios.post("/invest", payload)
            .then(({status, data})=>{
              if(status === 201){
                commit('InvestmentById', data)
                resolve(data);
                
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
      },

      GetUsersInvestment: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.get(`/invest?user=${payload.id}`)
          .then(({data, status})=>{
            if(status === 200){
              commit('investment', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      GetTransactions: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.get(`/transactions?user=${payload.id}`)
          .then(({data, status})=>{
            if(status === 200){
              commit('Transactions', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      GetInvestmentById: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.get('/invest/'+payload)
          .then(({data, status})=>{
            if(status === 200){
              commit('InvestmentById', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      CancelInvestment: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.delete('/invest/'+payload)
          .then(({data, status})=>{
            if(status === 200){
              
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      ActivateInvestment: ({commit}, payload) =>{
        return new Promise((resolve, reject)=>{
          axios.get("/invest/activate/"+payload)
          .then(({data, status})=>{
            if(status === 200){
              commit()
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
    },

      GetFarmsTotal: ({commit}) => {
        return new Promise((resolve, reject)=>{
          axios.get("/count/farms")
          .then(({data, status})=>{
            if(status === 200){
              commit('FarmCount', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      GetInvestTotal: ({commit}) => {
        return new Promise((resolve, reject)=>{
          axios.get("/count/invest")
          .then(({data, status})=>{
            if(status === 200){
              commit('InvestCount', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      GetUsersTotal: ({commit}) => {
        return new Promise((resolve, reject)=>{
          axios.get("/count/users")
          .then(({data, status})=>{
            if(status === 200){
              commit('UsersCount', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      GetFarmByFilter: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
            axios.get(`/farms?category=${payload.cat}`)
            .then(({data, status})=>{
            if(status === 200){
                commit('Farms', data)
                resolve(data);
            }
            })
            .catch((error)=>{
                reject(error);
            });
        })
    },
    GetFarmFilter: ({commit}, word) => {
        commit('SetFarmFilter', word)
            
    },
    ActivateFarm: ({commit}, payload) => {
      return new Promise((resolve, reject)=>{
        axios.get('/farms/activate/'+payload)
        .then(({data, status})=>{
          if(status === 200){
            resolve(data);
            commit()
          }
        })
        .catch((error)=>{
          reject(error);
        });
      })
    },
    DeactivateFarm: ({commit}, payload) => {
      return new Promise((resolve, reject)=>{
        axios.delete('/farms/'+payload)
        .then(({data, status})=>{
          if(status === 200){
            resolve(data);
            commit()
          }
        })
        .catch((error)=>{
          reject(error);
        });
      })
    },
      
  }
}